export default __webpack_public_path__ + "static/media/cloud.c47340c5.svg";